import memoizeOne from 'memoize-one'
import isEmpty from 'lodash/isEmpty'

export const pad = memoizeOne((num, size) => {
  return (`000000000${num}`).substr(-size)
})

export const to_unixtime = (date) => {
  return Math.floor(date.getTime() / 1000)
}

export const is_config_complete = (config) => {
  const {auth_token, owner, repo} = config
  return [auth_token, owner, repo].every((e) => !isEmpty(e))
}

export const DEBUG = process.env.NODE_ENV === 'development'
